import { GAME_ID } from '../../data/constants';
import Env from '../../../../lib/Env';

const initState = {
  isDev: Env.isLocalDev,
  isOnboardingOff: false,
  round: false,
  isImmortal: false,
  recordingControlType: 'manual', // 'auto' or 'manual'
  withRecordingUpload: false, // whether to upload recordings to S3
};

const screenReducer = (state = initState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case 'DEBUG_SET_ROUND':
      return {
        ...state,
        round: payload,
      };

    case 'DEBUG_SET_ONBOARDING':
      return {
        ...state,
        isOnboardingOff: payload,
      };

    case 'DEBUG_SET_IMMORTALITY':
      return {
        ...state,
        isImmortal: payload,
      };

    case 'DEBUG_SET_RECORDING_CONTROL_TYPE':
      return {
        ...state,
        recordingControlType: payload,
      };

    case 'DEBUG_SET_WITH_RECORDING_UPLOAD':
      return {
        ...state,
        withRecordingUpload: payload,
      };

    default:
      return state;
  }
};

export default screenReducer;
